import { setAlert } from "../alert";
import { SET_PROPERTY_FIELDS } from "../../types";
import { NumberValidator } from "../../../helpers/Validation";
import { getMiscContractByCode } from "../misc/contracts";
import {
    setUnmarketableFlag,
    calcPropertyOccupiedVacantSpace
} from "./properties";

/**
 * @name    updateAcquisition
 * @param   event
 * @returns {function(...[*]=)}
 */
export const updateAcquisition = event => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields } } = getState();
        const newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };

        //  DESC: Update Property value and  to re-calculate data
        const sqft_of_an_acre = 43560;

        //  DESC: Checking for number field and check for negative value. If negative, throw error
        //  DESC: isNumberNegative is a quick method to check for negative value. true or false
        //	TODO: This should deprecated now since Settings has validation
        if (event.target.type === "number") {
            if (NumberValidator.isNumberNegative(event.target.value)) {
                throw new TypeError(
                    `${event.target.dataset.displayName} can not be negative.`
                );
            }
        }

        const { lot_size, lot_sqft } = newPropertyFields;

        //  DESC: Converting acre to sqft
        if (event.target.name === "lot_size") {
            newPropertyFields.lot_sqft = (
                parseFloat(lot_size) * sqft_of_an_acre
            ).toFixed(2);
        }

        //  DESC: Converting sqft to arce
        if (event.target.name === "lot_sqft") {
            newPropertyFields.lot_size = (
                parseFloat(lot_sqft) / sqft_of_an_acre
            ).toFixed(5);
        }
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
    finally {
        //	POST_UPDATE
        switch (event.target.name) {
            case "group_code":
                dispatch(getMiscContractByCode(event.target.value));
                break;
            case "status_secondary":
                console.debug(event.target.name);
                dispatch(setUnmarketableFlag());
                break;
            case "building_size":
            case "property_management_leased_space":
                dispatch(calcPropertyOccupiedVacantSpace());
                break;
            default:
                break;
        }
    }
};
